<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter110">
<div class="extract">
<p class="extractText1"><span class="character-style7">“I enlisted right after Pearl Harbor when I was at West Virginia University. My friend and I skipped school for a couple of days and hitch-hiked to Pikeville, Kentucky to take the aviation cadet exam. We were sworn in as privates after passing all the tests and told to standby at home. They called me in during April ’42 as a cadet to take basic training and then start flight training.”</span></p>
</div>
<p class="paraNoIndent"><span class="character-style7">Captain Norm Rosholt, six Air Medals, Purple Heart, flew the B-17 Flying Fortress in combat missions over Europe with the 452nd Bomber Group based at Deopham Green in Norfolk.</span></p>
<div class="extract">
<p class="extractText1"><span class="character-style7">“I was born in Montana, went to high school in North Dakota and college in Iowa. I enlisted in the reserves in 1942. I then went to the south-west US to do my flying training.”</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter110.vue?1f25e42d